import { Property } from 'csstype';

export function positions(position: Property.Position) {
    return position;
}

export function display(position: Property.Display) {
    return position;
}
